import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, Space, Tooltip, Button, PageHeader, Tag } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import { handleApiSuccess, handleApiError, MyBreadcrumb, confirmDelete } from "utils";
import {
  billingTaxRateListService,
  billingTaxRateDeleteService,
} from "services/billing";

export default function TaxRateIndex() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const appliesLabel = {
    PHYSICAL_GOOD: "Physical Goods",
    SERVICE: "Services",
    BOTH: "All Items",
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (t) => <Tag>{t}</Tag>,
    },
    {
      title: "Rate",
      dataIndex: "rate_percentage",
      key: "rate_percentage",
      render: (t) => (t || t === 0 ? Number(t).toFixed(2) + "%" : ""),
    },
    {
      title: "Applies To",
      dataIndex: "applies_to",
      key: "applies_to",
      render: (t) => appliesLabel[t] || t,
    },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (t) =>
        t ? <Tag color="green">Active</Tag> : <Tag>Inactive</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <Button
              onClick={() => history.push("/billing/tax-rates/update/" + record._id)}
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              onClick={() => deleteRecord(record._id)}
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setIsLoading(true);
    billingTaxRateListService()
      .then((response) => {
        setIsLoading(false);
        setDataSource(response.data.items || []);
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  const deleteRecord = (id) => {
    confirmDelete().then(() => {
      setIsLoading(true);
      billingTaxRateDeleteService(id)
        .then((response) => {
          handleApiSuccess(response);
          loadData();
        })
        .catch((error) => {
          setIsLoading(false);
          handleApiError(error);
        });
    });
  };

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Tax Rates", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <PercentageOutlined /> }}
        title="Tax Rates"
        subTitle="State-based tax rates auto-applied by the customer's state"
        extra={[
          <Button
            key="create"
            shape="round"
            onClick={() => history.push("/billing/tax-rates/create")}
            type="primary"
            icon={<PlusCircleOutlined />}
          >
            Add Tax Rate
          </Button>,
        ]}
      />
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        rowKey="_id"
      />
    </div>
  );
}
